export default __webpack_public_path__ + "0b658e068d00474921edfa0ddc3871e0.svg";